<template>
  <div class="section-panel text-center">
    <div class="container-fluid">
      <div class="title">
        <h3>{{$t('settings.permissions')}}</h3>
      </div>
      <div class="text-left">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/panel/settings?active=roles' }">Permisos</el-breadcrumb-item>
            <el-breadcrumb-item>{{modeForm}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="col-md-8 ml-auto mr-auto">
        <div class="card plain">
            <div class="card-body">
            <form id="form-permission" role="form" @submit.prevent="onFormSubmit"  v-loading="loading">
                <div class="title">
                  Asignar Permisos
                </div>
                <div class="description">
                  <span>Selecciona de la lista, los permisos que deseas agregar al perfil</span>
                </div>
                <br>
                <br>
                <br>
                <div class="row p-2" v-for="(group, g) in resources" :key="g">
                    <div class="col-md-12 text-left">
                        <span class="title">{{group.name}}</span>
                        <el-divider></el-divider>
                        <div class="row" v-for="(resource, r) in group.resources" :key="r">
                          <div class="col-md-2">
                            <el-switch
                              active-color="#13ce66"
                              v-model="resource.selected">
                            </el-switch>
                          </div>
                          
                          <div class="col-md-10 text-left">
                            {{resource.name}}
                          </div>
                          <br>
                          <br>
                        </div>
                        <el-divider></el-divider>

                    </div>
                </div>
                
                <div class="card-footer text-center">
                    <router-link
                        class="btn text-white btn-round btn-default"
                        to="/panel/settings?active=roles">
                        {{$t('settings.button_cancel')}}
                    </router-link>
                    &nbsp;
                    <el-button size="medium" type="info" round native-type="submit">
                        {{$t('settings.button_save')}}
                    </el-button>
                </div>
                

            </form>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput } from '@/components';
import { DatePicker,Breadcrumb, BreadcrumbItem, Divider, Input, Button, MessageBox, Message, Select, Option, Switch } from 'element-ui';
import _ from 'lodash'

import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
  name: 'permission-form',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Input.name]: Input,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
  },
  data() {
    return {
        loading: false,
        formData: {
          ids: []
        },
        resources: [],
        resourceSelect: null,
        modeForm: 'New'
    }
  },
  mounted() {
    this.getPermissions()
  },
  computed: {
    
  },
  methods: {
    onFormSubmit () {
      // this.loading = true
      let id = this.$route.params.id
      if (id) {
        let toLink = []
        
        _.each(this.resources, (g) => {
          _.each(g.resources, (r) => {
            if(r.selected){
              toLink.push(r.id)
            }
          })
        })
        
        this.formData.ids = toLink
        
        provider.assignPermissions(id, this.formData).then((response) => {
          this.error = null
          Message({
            type: 'success',
            message: 'Operación exitosa'
          })
          setTimeout(() => {
              this.loading = false
              this.$router.push('/panel/settings?active=roles')
          }, 1000);
        }).catch((err) => {
          this.loading = false
          console.info('error post users request')
          console.info(err)
        })
      }
    },
    getPermissions() {
      // this.loading = true
      let id = this.$route.params.id
      provider.getResourcesByRole(id).then((resp) => {
        this.resources = resp.data.data
      }).catch((err) => {
        this.loading = false
        console.info('error get resources request')
        console.info(err)
      })
    }
  },
  watch: {
  }
};
</script>
<style>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demo-input-label {
    text-align: center !important;
    display: block;
    padding: 5px !important;
  }
</style>